import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements AfterViewInit {

  @ViewChild('features') features: ElementRef;
  @ViewChild('details') details: ElementRef;
  @ViewChild('concept') concept: ElementRef;
  @ViewChild('opportunities') opportunities: ElementRef;
  @ViewChild('footer') footer: ElementRef;

  constructor() { }

  ngAfterViewInit(): void { }

  onClickFeatures() {
    this.smoothScroll(this.features.nativeElement);
  }

  onClickDetails() {
    this.smoothScroll(this.details.nativeElement);
  }

  onClickConcept() {
    this.smoothScroll(this.concept.nativeElement);
  }

  onClickOpportunities() {
    this.smoothScroll(this.opportunities.nativeElement);
  }

  smoothScroll(target: HTMLElement | any) {
    let scrollContainer = target;
    do {
      scrollContainer = scrollContainer.parentNode;
      if (!scrollContainer) return;
      scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    let targetY = 0;
    do {
      if (target == scrollContainer) break;
      targetY += target.offsetTop;
    } while (target = target.offsetParent);

    const scroll = (c, a, b, i) => {
      i++; if (i > 30) return;
      c.scrollTop = a + (b - a) / 30 * i;
      setTimeout(() => { scroll(c, a, b, i); }, 20);
    }
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
  }

}
